import { CALL_API } from 'redux-api-middleware'
import { token } from '../utils'
import {
  LOAD_DASHBOARD_REQUEST,
  LOAD_DASHBOARD_SUCCESS,
  LOAD_DASHBOARD_FAILURE,
} from './types'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
export const loadDashboardPage = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [LOAD_DASHBOARD_REQUEST, LOAD_DASHBOARD_SUCCESS, LOAD_DASHBOARD_FAILURE],
  },
})



// WEBPACK FOOTER //
// ./src/actions/creatorDashboard.js